import React, { useEffect, useState } from "react";
import {
  useLocation,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { nanoid } from "nanoid";
import { calcDisplayNo, extractAllClasses } from "../../AppManager";
import ClassCard from "../../components/ClassCard";
import EmptySearch from "../../components/EmptySearch";
import Filter from "../../components/Filter";
import Pagination from "../../components/Pagination";

function AdminClasses() {
  const path = useLocation().pathname;
  const { search, record, setShowSearch } = useOutletContext();
  const [classes, setClasses] = useState([]);
  const [searchParams] = useSearchParams();
  const classFilter = searchParams.get("trainingClass");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    let page = searchParams.get("page") || 1;
    page = parseInt(page);
    page = page > 0 ? page : 1;

    let limit = searchParams.get("limit") || 10;
    limit = parseInt(limit);
    limit = limit > 0 ? limit : 10;
    setPagination({ page, limit });
  }, [searchParams]);

  useEffect(() => {
    const width = 210;
    const height = 150;
    const pagePadMarginWidth = 20;
    const pagePadMarginHeight = 20;
    setPagination((old) => ({
      ...old,
      limit: calcDisplayNo(
        width,
        height,
        pagePadMarginWidth,
        pagePadMarginHeight
      ),
    }));
    window.addEventListener("resize", () => {
      setPagination((old) => ({
        ...old,
        limit: calcDisplayNo(
          width,
          height,
          pagePadMarginWidth,
          pagePadMarginHeight
        ),
      }));
    });

    return () => {
      window.removeEventListener("resize", () => {
        setPagination((old) => ({
          ...old,
          limit: calcDisplayNo(
            width,
            height,
            pagePadMarginWidth,
            pagePadMarginHeight
          ),
        }));
      });
    };
  }, []);

  useEffect(() => {
    let classes = extractAllClasses(record);
    if (classFilter)
      classes = classes.filter((dat) => dat.trainingClass === classFilter);
    classes = classes.filter(
      (dat) => dat.name.toLowerCase().indexOf(search.toLowerCase()) > -1
    );

    setClasses(classes);
  }, [record, classFilter, search]);

  useEffect(() => {
    setShowSearch(true);
  });

  document.title = "Classes";

  const { page, limit } = pagination;
  const start = (page - 1) * limit;
  const end = start + limit;

  const classesElement = classes
    .slice(start, end)
    .map((dat) => <ClassCard key={dat.name} name={dat.name} to={dat.name} />);

  path === "/admin/students" &&
    classesElement.unshift(
      <ClassCard
        key={nanoid()}
        name={"All Students"}
        to={"/admin/overview/allstudents"}
      />
    );
  path === "/admin/teachers" &&
    classesElement.unshift(
      <ClassCard
        key={nanoid()}
        name={"All Teachers"}
        to={"/admin/overview/allteachers"}
      />
    );

  return (
    <div className="overview-students">
      {classes.length !== 0 && <Filter classFilter={classFilter} />}
      {classesElement.length === 0 ? (
        <EmptySearch message={"No Class Found"} />
      ) : (
        <>
          {classesElement}
          <Pagination
            limit={pagination.limit}
            currentPage={pagination.page}
            totalPages={Math.ceil(classes.length / pagination.limit)}
          />
        </>
      )}
    </div>
  );
}

export default AdminClasses;
